import { startCase } from 'lodash';
import React from 'react';
import { Label } from 'react-bootstrap';

const getLabelStyle = (status, policy, quoteType) => {
  if (quoteType === 'mid term adjustment' && status === 'quote') {
    return 'warning';
  }

  if (
    status === 'quote' ||
    status === 'referral approved' ||
    status === 'on cover' ||
    status === 'active' ||
    status === 'issued' ||
    status === 'on cover'
  ) {
    return 'success';
  }

  if (status === 'declined' || status === 'cancelled') {
    return 'danger';
  }

  if (status === 'referred') {
    return 'warning';
  }

  return 'default';
};

const PolicyLabel = ({ status, policyNumber, quoteType, label }) => {
  return (
    <Label
      className="pull-right"
      bsStyle={getLabelStyle(status, policyNumber, quoteType)}
    >
      {startCase(label)}
    </Label>
  );
};
export default PolicyLabel;
